import { z } from 'zod';
import { hqHalfyearPeriodSchema, hqHalfyearTopicIdSchema } from './hq-halfyear-review';
import { hqHistoricalSummarySchema } from './hq-historical-reports';

const id = z.string().regex(/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/u);
export const hqControlQuerySchema = hqHalfyearPeriodSchema.extend({}).strict();
export const hqControlMetricSchema = z.object({
  key: id, label: z.string().min(1).max(200), unit: z.enum(['건', '명', '원']),
  value: z.number().finite().nonnegative().nullable(),
  period: z.string().max(100),
}).strict();
export const hqControlSourceSchema = z.object({
  topicId: hqHalfyearTopicIdSchema, featureId: id.nullable(), label: z.string().min(1).max(200),
  state: z.enum(['saved', 'partial', 'missing', 'unavailable', 'denied', 'not-connected']),
  savedAt: z.string().datetime().nullable(), pending: z.boolean(),
  message: z.string().max(500), metrics: z.array(hqControlMetricSchema).max(10),
}).strict().superRefine((source, ctx) => {
  if (!['saved', 'partial'].includes(source.state) && source.metrics.some(metric => metric.value !== null)) ctx.addIssue({ code: 'custom', message: 'Unavailable sources cannot contain authoritative counts' });
});
export const hqControlResultSchema = z.object({
  year: z.number().int().min(2000).max(2200), half: z.union([z.literal(1), z.literal(2)]),
  sites: z.array(z.object({ id, name: z.string().min(1).max(200), sources: z.array(hqControlSourceSchema).max(20) }).strict()).max(200),
  historical: hqHistoricalSummarySchema.nullable(), historicalState: z.enum(['saved', 'missing', 'unavailable']),
}).strict().superRefine((result, ctx) => {
  if (new Set(result.sites.map(site => site.id)).size !== result.sites.length || (result.historical && result.historical.year !== result.year)) ctx.addIssue({ code: 'custom', message: 'HQ control period or site binding mismatch' });
});
export type HqControlResult = z.infer<typeof hqControlResultSchema>;
export type HqControlSource = z.infer<typeof hqControlSourceSchema>;
